/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { TagOptions } from './tags.interface';
@Component({
  selector: 'tags-component',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss']
})
export class TagsComponent implements OnInit, OnChanges {
  @Input() options: TagOptions = {
                                    module:'',
                                  };
  @Output() tagsChanged: EventEmitter<any> = new EventEmitter();
  listValue$: Observable<any[]> = new Observable<any[]>();
  preloadedValue: any = [];
  valueSubject$: Subject<string | null> = new Subject<string | null>();
  lookupLoading: boolean = false;
  pageSize: number = 1;
  tags: any = [];
  moduleId: string = '';
  dataUrl: string;

  constructor(
    private dataCollectorService: DataCollectorService,
    private localStorageService: LocalStorageService
  ){}


  ngOnInit(): void {
    this.dataUrl = `${this.dataCollectorService.baseurl()}/company_tags`;
    this.moduleId = this.localStorageService.getLocalStorage('company_modules')?.find((data: any)=> data?.module?.module_key === this.options.module)?.module?.module_uid;
    this.setInitialListValue('');
    if(Array.isArray(this.options?.fieldValue) && this.options?.fieldValue?.length){
      this.options?.fieldValue.forEach((element: any)=>{
        this.setInitialListValue(element);
      });
      this.tags = this.options?.fieldValue;
    }
  }

  setInitialListValue(term = ''): void {
    if (this.dataUrl) {
      const paramObj = {
        'filter.module': this.moduleId,
        'page': this.pageSize,
        'filter.keyword': term,
        'limit': ''
      };
      this.dataCollectorService.getData(this.dataUrl, paramObj).subscribe((response: any) => {
            this.preloadedValue = [...this.preloadedValue,...response.data];
            this.loadLookupValues();
        });
    }
  }

  setListValue(term = ''): any {
    if([null,undefined].includes(term)){
      this.lookupLoading = false;
      return of(null);
    }
    const paramObj = {
      'filter.module': this.moduleId,
      'page': this.pageSize,
      'filter.keyword': term,
      'limit': ''
    };
    return this.dataCollectorService.getData(this.dataUrl, paramObj).pipe(
      map((response: any) => response?.data)
    );
  }

  addNewTag(event): void{
    let addedTag;
    if(!event?.tag_uid){
      addedTag = event?.tag_name;
      const payload = {
        'tag': {
          'tag_name': event?.tag_name,
          'module_uid': this.moduleId
        }
      };
      this.dataCollectorService?.postData(this.dataUrl,payload).subscribe((resposne: any)=>{});
    }
  }

  tagChanged(): void{
    this.tagsChanged.emit(this.tags);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if('options' in changes){
      if(Array.isArray(this.options?.fieldValue) && this.options?.fieldValue?.length){
        this.options?.fieldValue.forEach((element: any)=>{
          this.setInitialListValue(element);
        });
        this.tags = this.options?.fieldValue;
      }
    }
  }

  private loadLookupValues(): any {
    this.lookupLoading = false;
    this.listValue$ = concat(
      of(this.preloadedValue),
      this.valueSubject$.pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => (this.lookupLoading = true)),
        tap(() => (this.pageSize = 1)),
        switchMap((term: any) =>
          this.setListValue(term).pipe(
            catchError(() => of(this.preloadedValue)),
            tap(() => (this.lookupLoading = false))
          )
        )
      )
    );
  }

}


